/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import Popup from './Popup';

const IFRAME_PROPS = {
  width: '100%',
  height: '100%',
  frameBorder: 0,
};
class LinkPopup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onIframeLoad = this.onIframeLoad.bind(this);
    this.iframeRef = React.createRef();
  }

  onClick(event) {
    event.preventDefault();

    this.setState({ isOpened: true });
  }

  onClose() {
    this.setState({ isOpened: false });
  }

  onIframeLoad() {
    try {
      const anchors = Array.from(
        this.iframeRef.current.contentDocument.getElementsByTagName('a'),
      );

      anchors.forEach((item) => item.setAttribute('target', '_blank'));
    } catch (error) {
      console.error('Can not set target "_blank" to iframe links');
    }
  }

  render() {
    const { href, children, width, height, title, ...rest } = this.props;
    const { isOpened } = this.state;
    return (
      <>
        <a
          href={href}
          title={title}
          {...rest}
          onKeyUp={this.onClick}
          onClick={this.onClick}
        >
          {children}
        </a>
        <Popup
          open={isOpened}
          onClose={this.onClose}
          width={width}
          height={height}
        >
          <iframe
            onLoad={this.onIframeLoad}
            ref={this.iframeRef}
            title={title}
            src={href}
            {...IFRAME_PROPS}
          />
        </Popup>
      </>
    );
  }
}

LinkPopup.defaultProps = {
  title: null,
  width: 500,
  height: 500,
};

LinkPopup.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default LinkPopup;
